import { RocketLaunch } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import type { UsersT } from '@prismo-io/schemas';
import { SupabaseImage } from '@prismo-io/utils/client/supabase-image';
import { GetIntegrationAction } from '../api/get-integration.action';
import { ActionBtn } from './action-btn';
type Props = {
  toolId: string;
  user: Pick<UsersT, 'id' | 'url'>;
  order?: number;
};
export const TsidCard = async (props: Props) => {
  const {
    toolId,
    user,
    order = 1000
  } = props;
  const res = await GetIntegrationAction({
    toolId,
    userId: user.id
  });
  if (!res?.data) {
    return null;
  }
  const {
    data
  } = res;
  const {
    isMe,
    hasCurrent,
    tool
  } = data;
  if (!isMe && !hasCurrent) {
    return null;
  }
  return <Stack component="article" bgcolor={hasCurrent ? 'background.primary' : 'background.paper'} borderRadius="3rem" p={2} zIndex={10} minWidth={{
    none: '100%',
    sm: '45%',
    lg: '31%'
  }} boxShadow="2px 2px 7px 0px rgba(0,0,0,0.3)" flex="1 1 0%" direction="column" alignItems="center" order={order} spacing={2} data-sentry-element="Stack" data-sentry-component="TsidCard" data-sentry-source-file="index.tsx">
      <Box component="div" position="relative" width="10.5rem" height="10.5rem" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <SupabaseImage src={tool.logo} alt={tool.name} style={{
        objectFit: 'contain',
        objectPosition: 'center'
      }} fill bucket="tsid" replaceOnError={<RocketLaunch sx={{
        width: '100%',
        height: '100%'
      }} color="primary" />} data-sentry-element="SupabaseImage" data-sentry-source-file="index.tsx" />
      </Box>
      <Box component="div" width="fit-content" marginX="auto" bgcolor="background.primary" borderRadius={1_000_000} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Typography color="primary.main" textAlign="center" paddingY={1} paddingX={2} variant="h4" fontWeight="bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {tool.name}
        </Typography>
      </Box>
      <Box component="div" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <ActionBtn {...data} user={user} data-sentry-element="ActionBtn" data-sentry-source-file="index.tsx" />
      </Box>
    </Stack>;
};